import { useState } from "react";
import { chatThreads } from "@/mocks/evidence";

export default function ChatArchive() {
  const [sel, setSel] = useState(chatThreads[0].id);
  const thread = chatThreads.find((t) => t.id === sel) ?? chatThreads[0];

  return (
    <section id="chat" className="scroll-mt-24 border-y border-background-200 bg-background-100/70 py-10 md:py-12">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="flex items-center gap-2 font-display text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              <i className="ri-chat-3-fill text-primary-500" />
              聊天记录 · 打码档案
            </h2>
            <p className="mt-1 text-[13px] text-foreground-500">关键人物与号码已打码 · 仅保留时间戳与事件口径供比对</p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-shield-check-line text-primary-500" />
            已存证 {chatThreads.filter((t) => t.status === "已存证").length} / 全部核对中
          </span>
        </div>

        <div className="grid gap-5 lg:grid-cols-12">
          {/* 左：记录清单 */}
          <div className="flex flex-col gap-2 lg:col-span-4">
            {chatThreads.map((t) => {
              const on = t.id === sel;
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => setSel(t.id)}
                  className={`flex flex-col rounded-lg border p-3 text-left transition-colors ${
                    on
                      ? "border-primary-400 bg-background-50"
                      : "border-background-200 bg-background-50/60 hover:border-background-300"
                  }`}
                >
                  <div className="flex items-center justify-between gap-2">
                    <span className="truncate text-sm font-bold text-foreground-950">{t.title}</span>
                    <span
                      className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-bold ${
                        t.status === "已存证"
                          ? "bg-primary-100 text-primary-700"
                          : "bg-accent-100 text-accent-700"
                      }`}
                    >
                      {t.status}
                    </span>
                  </div>
                  <span className="mt-1 text-[11px] text-foreground-500">{t.parties}</span>
                  <span className="mt-1 text-[11px] text-foreground-400">{t.meta}</span>
                </button>
              );
            })}
            <div className="mt-1 rounded-lg border border-dashed border-background-300 p-3 text-[11px] leading-5 text-foreground-500">
              <i className="ri-information-line mr-1 text-accent-600" />
              单方流出内容仅作线索，不作为最终结论；曝瓜网持续做多方交叉核验。
            </div>
          </div>

          {/* 右：气泡视图 */}
          <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 lg:col-span-8">
            <div className="flex flex-wrap items-center justify-between gap-2 border-b border-dashed border-background-200 pb-3">
              <div>
                <h3 className="font-display text-base font-bold text-foreground-950">{thread.title}</h3>
                <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" /> {thread.meta}
                  </span>
                  <span>来源 · {thread.source}</span>
                </div>
              </div>
              <span className="flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-900">
                <i className="ri-lock-2-line" />
                {thread.bubbles.length} 条已打码
              </span>
            </div>

            {/* 气泡区 */}
            <div className="mt-4 space-y-3">
              {thread.bubbles.map((b, i) => (
                <div key={i} className={`flex ${b.side === "right" ? "justify-end" : "justify-start"}`}>
                  <div
                    className={`max-w-[82%] rounded-2xl px-3.5 py-2.5 text-sm leading-6 md:max-w-[70%] ${
                      b.side === "right"
                        ? "rounded-br-sm bg-primary-500 text-background-50"
                        : "rounded-bl-sm bg-background-200 text-foreground-900"
                    }`}
                  >
                    <div className={`mb-0.5 text-[11px] font-medium ${b.side === "right" ? "text-background-200" : "text-foreground-500"}`}>
                      {b.who} · {b.time}
                    </div>
                    {b.text}
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="mt-5 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-eye-line" />
              展开全部 {thread.bubbles.length} 条上下文
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}